export default __webpack_public_path__ + "static/media/cross.e302745f.svg";